"use strict";
// Generated by robots, do not change this manually!
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = exports.light = void 0;
var light_1 = require("./light");
Object.defineProperty(exports, "light", { enumerable: true, get: function () { return light_1.light; } });
var dark_1 = require("./dark");
Object.defineProperty(exports, "dark", { enumerable: true, get: function () { return dark_1.dark; } });
//# sourceMappingURL=index.js.map